// Get configuration from env.js endpoint 
export const AuthConfig = window.env.auth;
